export default {

    UNPAY : {
        id : 1,
        text : '待支付'
    },
    PAID : {
        id : 2,
        text : '已支付'    // 卖家角度：待发货
    },
    SHIPPED : {
        id : 3,
        text : '待收货'    // 卖家角度：已发货
    },
    RECEIVED : {
        id : 4,
        text : '已收货'
    },
    COMPLETED : {
        id : 5,
        text : '已完成'
    },
    CLOSED : {
        id : 9,
        text : '已关闭'
    },
    REFUNDING : {
        id : 10,
        text : '退款中'
    },
    REFUNDED : {
        id : 11,
        text : '已退款'
    },

    getTextById : function (id) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].id === id)
            {
                return this[key].text;
            }
        }

        return '';
    }

}
